/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { Observable, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { PaginationParams } from 'src/app/model/api/pagination-params';
import { debounceTime, filter, map } from 'rxjs/operators';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { TranslateService } from '@ngx-translate/core';
import { Site } from 'src/app/model/site';
import { RULE_DEFAULT_SORT_COLUMN, RULE_DEFAULT_SORT_COLUMN_DIRECTION, RULE_PAGE_DEFAULT_SIZE, RULE_PAGE_SIZE_OPTIONS, RULE_TABLE_HEADER } from 'src/app/conf/mtma-rules-access';
import { DatePipe } from '@angular/common';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { selectMtmaActiveTask, selectMtmaRuleModify, selectMtmaTimesliceModify, selectMtmaRules, selectMtmaRulesMaxData, selectMtmaRulesPagination } from 'src/app/store/device/device.selector';
import { ItemsPagination, MtmaMaxData } from 'src/app/model/api/data-rest';
import { MtmaTask } from 'src/app/model/mtma-task';
import { TableLazyLoadEvent } from 'primeng/table';
import { pageSortChange } from 'src/app/services/table';
import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MtmaRuleDialogComponent } from '../mtma-rule-dialog/mtma-rule-dialog.component';
import { MtmaRuleAccessDialogComponent } from '../mtma-rule-access-dialog/mtma-rule-access-dialog.component';
import { StandardMtmaLayout, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectDeviceTabIndex } from 'src/app/store/home/home.selector';
import { MtmaRule, MtmaTimeslice } from 'src/app/model/mtma-rules-access';
import { FlagTimeslice } from 'src/app/conf/flag-timeslices';

@Component({
	selector: 'app-mtma-rules-access-rules',
	templateUrl: './mtma-rules-access-rules.component.html',
	providers: [ConfirmationService, DialogService]
})

export class MtmaRulesAccessRulesComponent implements OnInit, OnDestroy {

	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;
	mtmaRules$: Observable<MtmaRule[] | undefined>;
	mtmaRulesSub: Subscription | undefined;
	mtmaRulesPagination$: Observable<ItemsPagination | undefined>;
	mtmaRulesPaginationSub: Subscription | undefined;
	mtmaRulesMaxData$: Observable<MtmaMaxData | undefined>;
	mtmaRulesMaxDataSub: Subscription | undefined;
	mtmaRuleModify$: Observable<boolean | undefined>;
	mtmaRuleModifySub: Subscription | undefined; ì
	mtmaActiveTask$: Observable<MtmaTask | undefined>;
	mtmaActiveTaskSub: Subscription | undefined;
	mtmaTimesliceModify$: Observable<boolean | undefined>;
	mtmaTimesliceModifySub: Subscription | undefined;
	tabIndex: number;
	tabIndex$: Observable<number | undefined>;
	tabIndexSub: Subscription | undefined;

	searchFilter: FormControl = new FormControl('');
	filterSub: Subscription;
	filter: '';

	ruleColumns = RULE_TABLE_HEADER;
	rulePagingSub: Subscription;
	rulePageSortSub: Subscription;
	rulePaging: PaginationParams = {
		size: RULE_PAGE_DEFAULT_SIZE,
		page: 1,
		sort: RULE_DEFAULT_SORT_COLUMN,
		order: RULE_DEFAULT_SORT_COLUMN_DIRECTION,
	};
	rulePageSize: number = RULE_PAGE_DEFAULT_SIZE;
	rulePageSizeOptions = RULE_PAGE_SIZE_OPTIONS;
	totalRecords: number;

	ruleMaxSizeMemorySub: Subscription;
	ruleMemorySize = 1;
	ruleMaxMemorySize = 1;

	ruleLoading: boolean;
	mtmaRules: MtmaRule[];

	currentSite: Site;

	ruleConfirmDeleteSub: Subscription;

	dateTransform: DatePipe;

	isActiveTask = false;
	ref: DynamicDialogRef | undefined;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	// Design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	COLUMN_TITLE_MIN_WD = 647;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_MX7 = 1700;
	LG_WIDTH = 1500;

	MAX_MD_WIDTH_SHORT = 858;
	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
		public dialogService: DialogService,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.site$ = this.store.select(selectCurrentSite);
		this.mtmaRules$ = this.store.select(selectMtmaRules);
		this.mtmaRulesPagination$ = this.store.select(selectMtmaRulesPagination);
		this.mtmaRulesMaxData$ = this.store.select(selectMtmaRulesMaxData);
		this.mtmaRuleModify$ = this.store.select(selectMtmaRuleModify);
		this.mtmaActiveTask$ = this.store.select(selectMtmaActiveTask);
		this.tabIndex$ = this.store.select(selectDeviceTabIndex);
		this.mtmaTimesliceModify$ = this.store.select(selectMtmaTimesliceModify);
	}

	ngOnInit(): void {
		const currentLang = this.translate.currentLang;

		this.dateTransform = new DatePipe(currentLang);

		this.siteSub = this.site$.subscribe(currentSite => {
			this.currentSite = currentSite;
		});

		this.mtmaActiveTaskSub = this.mtmaActiveTask$.subscribe(mtmaActiveTask => {
			if (mtmaActiveTask.Id !== '') {
				this.isActiveTask = true;
			} else {
				this.isActiveTask = false;
			}
		});
		this.tabIndexSub = this.tabIndex$?.subscribe(
			async (tabIndex: number) => {
				this.tabIndex = tabIndex;
				this.dispatchGetRules();
			});

		this.initRule();
		this.onResize();
	}

	initRule(): void {
		this.filterSub = this.searchFilter.valueChanges.pipe(
			debounceTime(500),
			map(v => v.trim().toLowerCase())
		).subscribe(value => {
			this.filter = value;
			this.dispatchGetRules();
		});
		this.dispatchGetRules();
		this.mtmaRulesSub = this.mtmaRules$.subscribe(mtmaRules => {
			this.mtmaRules = mtmaRules;
			this.ruleLoading = false;
		});

		this.rulePagingSub = this.mtmaRulesPagination$
			.pipe(filter(p => !!p))
			.subscribe(paging => {
				this.totalRecords = paging.TotalCount;
			}
			);

		this.ruleMaxSizeMemorySub = this.mtmaRulesMaxData$
			.pipe(filter(p => !!p))
			.subscribe(mtmaRulesMaxData => {
				this.ruleMemorySize = mtmaRulesMaxData.Current;
				this.ruleMaxMemorySize = mtmaRulesMaxData.Max;
			}
			);


		/*this.ruleFilterSub = this.ruleFilterForm.controls.searchFilter.valueChanges.pipe(
			debounceTime(500),
			map(v => v.trim().toLowerCase())
		).subscribe(value => {
			this.ruleFilter = value;
			this.paginator.firstPage();
			this.dispatchGetRules();
		});*/

		this.mtmaRuleModifySub = this.mtmaRuleModify$
			.pipe(filter(mtmaRuleModify => !!mtmaRuleModify))
			.subscribe(() => {
				this.dispatchGetRules();
			});


		this.mtmaTimesliceModifySub = this.mtmaTimesliceModify$
			.pipe(filter(mtmaTimesliceModify => !!mtmaTimesliceModify))
			.subscribe(() => {
				this.dispatchGetRules();
			});
	}

	ngOnDestroy(): void {
		this.mtmaTimesliceModifySub?.unsubscribe();
		this.siteSub?.unsubscribe();
		this.mtmaActiveTaskSub?.unsubscribe();
		this.mtmaRuleModifySub?.unsubscribe();
		this.ruleMaxSizeMemorySub?.unsubscribe();
		this.tabIndexSub?.unsubscribe();
	}

	getRepetitionTimeslice(timeslice: MtmaTimeslice): number {
		const listFlag = [];
		let value = timeslice.Flags;
		for (let i = 3; i > -1; i--) {
			if (value !== 0 && value / (2 ** i) >= 1) {
				listFlag.push(1);
			} else {
				listFlag.push(0);
			}
			value = value % (2 ** i);
		}
		if (listFlag[3 - FlagTimeslice.REPETITION_MONTHLY] === 1) {
			return FlagTimeslice.REPETITION_MONTHLY;
		} else if (listFlag[3 - FlagTimeslice.REPETITION_ANNUAL] === 1) {
			return FlagTimeslice.REPETITION_ANNUAL;
		}
		return 0;
	}

	getIncludeExcludeTimeslice(timeslice: MtmaTimeslice): number {
		const listFlag = [];
		let value = timeslice.Flags;
		for (let i = 5; i > -1; i--) {
			if (value !== 0 && value / (2 ** i) >= 1) {
				listFlag.push(1);
			} else {
				listFlag.push(0);
			}
			value = value % (2 ** i);
		}
		if (listFlag[5 - FlagTimeslice.ESCLUDE_INCLUDE] === 1) {
			return 1;
		}
		return 0;
	}


	loadRule(event: TableLazyLoadEvent) {
		this.ruleLoading = true;

		this.rulePaging = pageSortChange(this.rulePaging, event);

		this.dispatchGetRules();
	}

	dispatchGetRules(): void {
		if (this.isSelectTab()) {
			this.store.dispatch(DeviceActions.getMtmaRules({
				filter: this.filter,
				sort: this.rulePaging.sort, order: this.rulePaging.order, size: this.rulePaging.size, page: this.rulePaging.page
			}));
		}
	}

	isMtmaConnect(): boolean {
		//return (this.deviceModel !== undefined && (this.deviceModel.Id === EDeviceModel.MTMACONNECT) && this.tabIndex === 9); // TAB INDEX FOR MTMACONNECT CALLLOG IS 9
		return (this.tabIndex === 8); // TAB INDEX FOR MTMACONNECT IS 8 tab only for mtma

	}

	isSelectTab(): boolean {
		return this.isMtmaConnect();
	}



	addRule(): void {
		this.store.dispatch(DeviceActions.resetRuleForm());
		this.ref = this.dialogService.open(MtmaRuleDialogComponent, {
			header: this.translate.instant('ADD_RULE'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
		});
	}

	editRule(rule: MtmaRule): void {
		this.store.dispatch(DeviceActions.resetRuleForm());
		this.ref = this.dialogService.open(MtmaRuleDialogComponent, {
			header: this.translate.instant('EDIT_RULE'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: { rule },
		});
	}

	deleteRule(rule: MtmaRule): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('DELETE_RULE'),
			message: this.translate.instant('DELETE_RULE_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(DeviceActions.deleteMtmaRule({ ruleId: rule.Id }));
			},
			reject: () => {
			}
		});
	}

	openRuleAccess(rule: MtmaRule): void {
		this.store.dispatch(DeviceActions.resetMtmaRulesAccessForm());
		this.ref = this.dialogService.open(MtmaRuleAccessDialogComponent, {
			header: this.translate.instant('MANAGE_ACCESS'),
			width: '75vw',
			breakpoints: { '1250px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: { rule },
		});
	}


	getNumTimeslot(rule: MtmaRule): number {
		if (rule.Timeslices === undefined) {
			return 0;
		}
		const listTimeslot = rule.Timeslices.filter(t => t.Type === 1);
		if (listTimeslot !== undefined) {
			return listTimeslot.length;
		}
		return 0;
	}


	getNumSpecialPeriod(rule: MtmaRule): number {
		if (rule.Timeslices === undefined) {
			return 0;
		}
		const listTimeslot = rule.Timeslices.filter(t => t.Type === 2);
		if (listTimeslot !== undefined) {
			return listTimeslot.length;
		}
		return 0;
	}

	getValueMemory(): number {
		return Math.ceil((this.ruleMemorySize / this.ruleMaxMemorySize) * 100);
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	actionLayout(position: string): string {
		return StandardMtmaLayout.actionLayout(this.screenWidth, position);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-25rem');
	}

	dynamicInputSearchWidth(): string {
		return StandardMtmaLayout.dynamicInputSearchWidth(this.screenWidth, 'w-25rem');
	}
}